export default __webpack_public_path__ + "static/media/razorpay_logo.048280fb.jpeg";